import Vue from "vue";

export const DialogBus = new Vue();


// WEBPACK FOOTER //
// ./src/smallComponents/Dialog/DialogBus.js